import { MultiLocaleString, UndefinedAble } from 'data/base';

export interface GuideSubStep {
  selector: string;
  content: MultiLocaleString;
  actionToComplete: string;
}

export interface GuideStep {
  location: string;
  subSteps: GuideSubStep[];
}

export interface GuideDescription {
  name: MultiLocaleString;
  detailFilePath: string;
}

export interface Guide extends GuideDescription {
  description: MultiLocaleString;
  steps: GuideStep[];
}

export interface OnGoingGuide extends Guide {
  currentStep: number;
  currentSubStep: number;
  isGUIReady: boolean;
}

export const getCurrentStep = (source: OnGoingGuide): GuideStep => {
  return source.steps[source.currentStep];
};

export const getCurrentSubStep = (source: OnGoingGuide): GuideSubStep => {
  return source.steps[source.currentStep].subSteps[source.currentSubStep];
};

export const isLastStep = (source: UndefinedAble<OnGoingGuide>): boolean => {
  if (source) {
    return (
      source.currentStep === source.steps.length - 1 &&
      source.currentSubStep ===
        source.steps[source.currentStep].subSteps.length - 1
    );
  } else {
    return false;
  }
};

export const isGuideWaitingForAction = (
  action: string,
  onGoingGuide: UndefinedAble<OnGoingGuide>
): boolean => {
  if (onGoingGuide) {
    const currentSubStep = getCurrentSubStep(onGoingGuide);
    return currentSubStep.actionToComplete === action;
  } else {
    return false;
  }
};
